import React from "react";

import { FieldGrid, LabeledField, SectionCard, TextInput } from "shared/ui";

import { useMenuSettingsContext } from "features/MenuSettings/context";
import { ContactField } from "features/MenuSettings/types";

const CONTACT_FIELDS: { field: ContactField; label: string; placeholder: string }[] = [
    { field: "phoneNumber", label: "Телефон", placeholder: "+7 900 000-00-00" },
    { field: "whatsApp", label: "WhatsApp", placeholder: "+7 900 000-00-00" },
    { field: "instagram", label: "Instagram", placeholder: "имя аккаунта" },
    { field: "telegram", label: "Telegram", placeholder: "имя аккаунта" },
    { field: "websiteUrl", label: "Сайт", placeholder: "example.ru" },
];

export const ContactsCard = () => {
    const { general } = useMenuSettingsContext();

    return (
        <SectionCard
            title="Контакты и соц. сети"
            description="Расскажите вашим клиентам как вас найти в социальных сетях и как с вами связаться."
        >
            <FieldGrid>
                {CONTACT_FIELDS.map((item) => (
                    <LabeledField key={item.field} label={item.label}>
                        <TextInput
                            value={general.contacts[item.field]}
                            placeholder={item.placeholder}
                            onChange={(value) => general.setContactField(item.field, value)}
                        />
                    </LabeledField>
                ))}
            </FieldGrid>
        </SectionCard>
    );
};
